'use strict';
'use strict';

import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Button, Form, Row, Col, Table, Card } from 'react-bootstrap';
import { Formik } from 'formik';
import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Separator from '../helper/Separator';
import Loader from '../helper/Loader';
import { getCurrencyFormatter, formatDate } from '../helper/DateTimeFormater';
function AdditionalContingent() {
    const { request } = useRequest();

    const [pricePerContingent, setPricePerContingent] = useState(null);
    const [aboStart, setAboStart] = useState(null);
    const [aboEnd, setAboEnd] = useState(null);
    const [aboPeriod, setAboPeriod] = useState(null);
    const [aboID, setAboID] = useState(null);
    const [remainingDays, setRemainingDays] = useState(null);
    const [newerAbo, setNewerAbo] = useState(false);
    const [contingent, setContingent] = useState(null);
    const [contingentPrice, setContingentPrice] = useState(0);
    const [step, setStep] = useState(0);

    const formRef = useRef(null);

    const cFormatter = getCurrencyFormatter();
    const handleAddContingent = async () => {
        const result = await request("/Business/AddContingent", { contingent: contingent, aboId: aboID });
        const json = result.data;
        if (json.r == 1) {
            toast.info("Kontingent hinzugefügt.");
            await timeout(2000);
            window.location.replace("/Business/Abo");
        }
        else {
            toast.error(json.message);
            setStep(0);
        }
    }

    function timeout(delay) {
        return new Promise(res => setTimeout(res, delay));
    }

    const setAdditionalContingent = async (value) => {
        setContingent(value)
        setStep(1);
        document.getElementById("content").scrollIntoView();
    }

    const back = () => {
        setStep(step => Math.max(0, Math.min(step - 1, 4)));
        document.getElementById("content").scrollIntoView();
    }

    useEffect(() => {
        const getPresets = async () => {
            try {
                let pathname = location.pathname.split("/");
                let id = pathname[pathname.length - 1];
                setAboID(id);
                let result = await request("/Business/GetAdditionalContingentInformation", { aboId: id });
                let json = result.data;
                if (json.r != 1) {                  
                    if (json.message) {
                        toast.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten.");
                    }
                }
                else {
                    setAboStart(json.start);
                    setAboEnd(json.end);
                    setAboPeriod(json.period);
                    setRemainingDays(json.remainingDays);
                    setNewerAbo(json.newerAbo);
                    setPricePerContingent(json.pricePerContingent.toFixed(2));
                }
            }
            catch {
                toast.error("Fehler beim Laden");
            }
        };
        getPresets();
    }, []);

    if (pricePerContingent === null) return <Loader />;

    // Paketauswahl
    if (step == 0) {
        return (
            <>
                <Separator text="Paketauswahl" />
                <p>Bitte wählen Sie Ihre gewünschte Paketerweiterung aus.</p>
                <p>Entspricht keine der Paketerweiterungen Ihren Ansprüchen? Dann kontaktieren Sie uns gerne per E-Mail.</p>
                <Table>
                    <thead>
                        <tr>
                            <th className="level-0 border-top-0">Paketerweiterungen</th>
                            <th className="level-1 text-center border-top-0">S</th>
                            <th className="level-2 text-center border-top-0">M</th>
                            <th className="level-3 text-center border-top-0">L</th>
                            <th className="level-4 text-center border-top-0">XL</th>
                         </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="level-0">Zusätzliches Kontingent</td>
                            <td className="level-1 text-center">5</td>
                            <td className="level-2 text-center">10</td>
                            <td className="level-3 text-center">25</td>
                            <td className="level-4 text-center">50</td>
                        </tr>
                        <tr>
                            <td className="level-0">Preis pro Kontingent</td>
                            <td className="level-1 text-center">{cFormatter.format(pricePerContingent)}</td>
                            <td className="level-2 text-center">{cFormatter.format((pricePerContingent * 0.975).toFixed(2))}</td>
                            <td className="level-3 text-center">{cFormatter.format((pricePerContingent * 0.95).toFixed(2))}</td>
                            <td className="level-4 text-center">{cFormatter.format((pricePerContingent * 0.925).toFixed(2))}</td>
                        </tr>
                        <tr>
                            <td className="level-0">Preis gesamt (exkl. MwSt)</td>
                            <td className="level-1 text-center">{cFormatter.format(pricePerContingent * 5)}</td>
                            <td className="level-2 text-center">{cFormatter.format((pricePerContingent * 0.975).toFixed(2) * 10)}</td>
                            <td className="level-3 text-center">{cFormatter.format((pricePerContingent * 0.95).toFixed(2) * 25)}</td>
                            <td className="level-4 text-center">{cFormatter.format((pricePerContingent * 0.925).toFixed(2) * 50)}</td>
                        </tr>
                        <tr className="book">
                            <td className="level-0"></td>
                            <td className="level-1 text-center"><button className="btn btn-secondary" onClick={() => {setAdditionalContingent(5); setContingentPrice(pricePerContingent)}}>Auswählen</button></td>
                            <td className="level-2 text-center"><button className="btn btn-secondary" onClick={() => {setAdditionalContingent(10); setContingentPrice(pricePerContingent * 0.975).toFixed(2)}}>Auswählen</button></td>
                            <td className="level-3 text-center"><button className="btn btn-secondary" onClick={() => {setAdditionalContingent(25); setContingentPrice(pricePerContingent * 0.95).toFixed(2)}}>Auswählen</button></td>
                            <td className="level-4 text-center"><button className="btn btn-secondary" onClick={() => {setAdditionalContingent(50); setContingentPrice(pricePerContingent * 0.925).toFixed(2)}}>Auswählen</button></td>
                        </tr>
                    </tbody>
                </Table>

                <div>
                    <Button type="button" variant="primary" onClick={() => location.pathname = "/Business/Abo"}><i className="fa-solid fa-chevron-left mr-2"></i>Zurück</Button>
                </div>
            </>
        );
    }

    // Übersicht + Bestätigung Buchung
    if (step == 1) {
        if (contingent === null) return <Loader />;

        return (
            <Formik
                innerRef={(f) => formRef.current = f}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={(values) => {
                    handleAddContingent(contingent);
                }}
                initialValues={
                        pricePerContingent, 
                        aboStart,
                        aboEnd, 
                        aboPeriod,
                        aboID,
                        remainingDays,
                        contingent
                }
            >
                {({
                    handleSubmit,
                }) => {

                    return (
                        <Form noValidate onSubmit={handleSubmit} className="mt-3">
                            <Separator text="Zusammenfassung" />
                            <Row className="mb-3">
                                <Col sm={12} lg={6}>
                                    <Card>
                                        <Card.Header>Ausgewähltes Kontingent-Paket</Card.Header>
                                        <Card.Body className="py-2">
                                            <Table size="sm" className="mb-0">
                                                <tbody>
                                                    <tr>
                                                        <td>Anzahl zusätzliches Kontingent</td>
                                                        <td className="text-right">
                                                            {contingent}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Abo-Start</td>
                                                        <td className="text-right">
                                                            {formatDate(aboStart)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Abo-Ende</td>
                                                        <td className="text-right">
                                                            {formatDate(aboEnd)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>verbleibende Paketlaufzeit</td>
                                                        <td className="text-right">
                                                            {remainingDays} Tage
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Preis pro Kontingent (exkl. MwSt)</td>
                                                        <td className="text-right">
                                                            {cFormatter.format(contingentPrice)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Preis Gesamt (exkl. MwSt)</td>
                                                        <td className="text-right">
                                                            {cFormatter.format(contingentPrice * contingent)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>                           
                            </Row>
                            <Row className="ml-3"> 
                                {(newerAbo) ? <p>Sie haben bereits ein nachfolgendes Abonnement gebucht. Möchten Sie dennoch eine Paketerweiterung für das ausgewählte Abonnement buchen?</p> : ''}
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Button type="button" variant="primary" onClick={() => back()}><i className="fa-solid fa-chevron-left mr-2"></i>Zurück</Button>
                                </Col>
                                <Col xs={6} className="text-right">
                                    <Button type="submit" variant="secondary"><i className="fa-solid fa-right-to-bracket mr-2"></i>Jetzt zahlungspflichtig bestellen</Button>
                                </Col>
                            </Row>
                        </Form>
                    )
                }}
            </Formik>
        );
    }
}

export default AdditionalContingent;